import './dateTransform';

import { milliseconds } from 'date-fns';
import { date, string } from 'yup';

const commonSchema = (type, errMsg, address) => {
  switch (type) {
    case 'salutation':
      return string().trim().max(50, errMsg);
    case 'title':
      return string().trim().max(50, errMsg);
    case 'firstName':
    case 'lastName':
      return string().trim().min(2, errMsg).max(50, errMsg).required(errMsg);
    case 'phone':
    case 'phone1':
      return string()
        .trim()
        .matches(/^[\d+-/\s]+$/g, errMsg)
        .max(25, errMsg);
    case 'phone2':
      return string()
        .trim()
        .matches(/^[\d+-/\s]+$/g, errMsg)
        .max(25, errMsg);
    case 'address':
      return string()
        .trim()
        .matches(/^([^0-9]*)$/, errMsg)
        .max(50, errMsg)
        .required(errMsg);
    case 'city':
      if (address)
        return string()
          .trim()
          .matches(/^([^0-9]*)$/, errMsg)
          .max(50, errMsg)
          .required('Ort fehlt');
      return string()
        .trim()
        .matches(/^([^0-9]*)$/, errMsg)
        .max(50, errMsg);
    case 'country':
      if (address)
        return string()
          .trim()
          .matches(/^([^0-9]*)$/, errMsg)
          .max(50, errMsg)
          .required('Land fehlt');
      return string()
        .trim()
        .matches(/^([^0-9]*)$/, errMsg)
        .max(50, errMsg);
    case 'houseNumber':
      if (address) return string().trim().matches(/\d/g, errMsg).required('Hausnummer fehlt');
      return string().trim().matches(/\d/g, errMsg);
    case 'postcode':
      if (address)
        return string()
          .trim()
          .matches(/^[0-9]+$/, errMsg)
          .length(5, errMsg)
          .required('Postleitzahl fehlt');
      return string()
        .trim()
        .matches(/^[0-9]+$/, errMsg)
        .length(5, errMsg);
    case 'postcodeService':
      return string()
        .trim()
        .matches(/^[0-9]+$/, errMsg)
        .length(5, errMsg);
    case 'birthDate':
      return date().dateTransform('dd.MM.yyyy').typeError(errMsg).required('Geburtsdatum fehlt');
    case 'moveInDate':
      return date().dateTransform('dd.MM.yyyy').typeError(errMsg).required(errMsg);
    case 'email':
      return string().trim().required(errMsg).email(errMsg).max(50, errMsg);
    case 'message':
    case 'reason':
    case 'proceedingId':
    case 'name':
      return string().trim().required(errMsg);
    case 'dueDate':
      return string()
        .trim()
        .test('dueDate-range', errMsg, (dueDate = '') => {
          if (!dueDate) return true;
          const [dd, mm, yy] = dueDate.split('.');

          const day = parseInt(dd, 10);
          const month = parseInt(mm, 10);
          const year = parseInt(yy, 10);

          if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

          const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

          if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;

          return day > 0 && day <= monthLength[month - 1];
        });

    case 'time':
      return string()
        .trim()
        .test('time-range', errMsg, (time = '') => {
          if (!time) return true;
          const [hours, minutes] = time.split(':');
          const currTime = milliseconds({ hours, minutes });
          const maxTime = milliseconds({ hours: 24, minutes: 0 });

          return maxTime > currTime;
        });

    default:
      return undefined;
  }
};

const createCommonSchema = (initialValues = {}, address = false) => {
  const fieldNames = Object.keys(initialValues);
  return !Array.isArray(fieldNames) || fieldNames.length === 0
    ? undefined
    : (errMsg) =>
        fieldNames.reduce((acc, fieldName) => {
          return {
            ...acc,
            [fieldName]: commonSchema(fieldName, errMsg, address),
          };
        }, {});
};

export default createCommonSchema;
